const GlobalComponents = {
  install (Vue) {

    //Global Methods
    Vue.prototype.$showLocalizedField = function (field,locale) {
      return field.filter(f=>{return f.locale == locale})[0] || field[0]
    }
  }
}

export default GlobalComponents